import React from 'react';
import { observer } from 'mobx-react-lite';

import Table from '@vromo/ui/components/Table';

interface Props {
    actualJobsCompleted: number;
    actualJobsCancelled: number;
    averageJobRating: number;
}

export default observer<Props>(function QuickStatsTable({
    actualJobsCompleted,
    actualJobsCancelled,
    averageJobRating
}) {
    const averageJobRatingDisp =
        averageJobRating >= 0 ? `${averageJobRating.toFixed(1)} / 5` : 'N/A';

    return (
        <Table>
            <tbody>
                <tr>
                    <td>
                        <b>Total Jobs</b>
                    </td>
                    <td>{actualJobsCompleted + actualJobsCancelled}</td>
                </tr>
                <tr>
                    <td>Jobs Completed</td>
                    <td>{actualJobsCompleted}</td>
                </tr>
                <tr>
                    <td>Jobs Cancelled</td>
                    <td>{actualJobsCancelled}</td>
                </tr>
                <tr>
                    <td>Average Customer Rating</td>
                    <td>{averageJobRatingDisp}</td>
                </tr>
            </tbody>
        </Table>
    );
});
